import { render, staticRenderFns } from "./estimate-supplements.vue?vue&type=template&id=37d81202"
import script from "./estimate-supplements.vue?vue&type=script&lang=js"
export * from "./estimate-supplements.vue?vue&type=script&lang=js"
import style0 from "./estimate-supplements.vue?vue&type=style&index=0&id=37d81202&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports